import { CustomFieldCell } from '@src/shared/features/custom-fields/components/custom-field-cell';

import type { CellContext, ColumnDef } from '@tanstack/react-table';
import type { TCustomField } from '@src/shared/types/custom-field';

export function generateCustomFieldColumns<
  T extends { id: number; custom_fields?: TCustomField[] },
>(data: T[]): ColumnDef<T>[] {
  return (
    data?.[0]?.custom_fields?.map((q, idx) => {
      return {
        accessorFn: (row) => row.custom_fields?.[idx]?.value?.value?.[0],
        id: `${q.id}-${idx}`,
        header: q.label,
        sortUndefined: 'last',
        cell: (props: CellContext<T, unknown>) => {
          const { row } = props;

          return (
            <CustomFieldCell
              entity={row.original}
              index={idx}
            />
          );
        },
      };
    }) || []
  );
}
